// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__hgDvi","content":"main_content__udxTs"};